import React from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { acceptHPDPendingTickets } from '../../../../../sevices/violationsApi';

import { Button, CircularProgress } from '@mui/material';
import toast from 'react-hot-toast';

function AcceptTickets({ row }) {

    const queryClient = useQueryClient();

    const { mutate: acceptHPDPendingTicketsMutation, isPending } = useMutation({
      mutationFn: acceptHPDPendingTickets,
      onSuccess: (res) => {
        toast.success(res?.data?.message);
      queryClient.invalidateQueries({ queryKey: ['accept-hire-requests'] });
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message);
      },
    });

    const handleAccept = async (row) => {
      try {
        acceptHPDPendingTicketsMutation({
          violation_id: row.violation.violation_id,
          client_id: row.client_id,
          unit_id: row.unit_id,
        });
      } catch (error) {
        console.error(error);
      }
    };
  return (
    <Button
      variant="contained"
      className="pending-requests-accept-btn"
      onClick={() => handleAccept(row)}
      disabled={isPending}
      startIcon={isPending && <CircularProgress size={20} color="inherit" />}
    >
      {isPending ? "Accepting..." : "Accept"}
    </Button>
  );
}

export default AcceptTickets